import React, { useState } from "react";

const ViewInjIsokinetic = ({ stepData }: any) => {

    // console.log(stepData);
    

    return (
        <>
            <div className="content container" style={{ maxWidth: "1500px", paddingTop: "10px" }}>
                <div className="row">
                    <div className="sortby-section">
                        <div className="sorting-info">
                            <div className="row align-items-center">
                                <div className="col d-flex justify-content-between">
                                    <h4>Isokinetic</h4>
                                </div>
                            </div>
                            <div className="card-body">
                                <table className="table">
                                    <thead>
                                        <tr>
                                            <th>Test Speed</th>
                                            <th>Parameter Name</th>
                                            <th>Percentage Value</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {stepData.map((row: any, index: number) => (
                                            <tr key={index}>
                                                <td>{row.speed}</td>
                                                <td>{row.parameter}</td>
                                                <td>{row.value}</td>
                                            </tr>
                                        ))}
                                        </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );

}

export default ViewInjIsokinetic;